import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=f8a2b2a6&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=f8a2b2a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8a2b2a6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f8a2b2a6')) {
      api.createRecord('f8a2b2a6', component.options)
    } else {
      api.reload('f8a2b2a6', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=f8a2b2a6&scoped=true&", function () {
      api.rerender('f8a2b2a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2pbYdaOFtBoPc/JS/comp/GuestBox.vue"
export default component.exports